import { Periods } from 'components/ProFormaReturnsTable/constant';
import { ICashFlowBudgetClassification, IPeriodData } from 'views/ProFormaTable/types';

export const getUsesPeriodDisplayValue = (period: IPeriodData, currentPeriodReached: boolean) => {
    let value = 0;

    if (period.inCurrentPeriod) {
        value = (period?.funding || 0) + (period?.projected || 0);
        return { value, currentPeriodReached: true };
    } if (!currentPeriodReached) {
        value = period?.funding || 0;
    } else {
        value = period?.projected || 0;
    }

    return { value, currentPeriodReached };
};

export const calculatePeriodTotals = (
    budgetClassifications: ICashFlowBudgetClassification[] = [],
    periods: IPeriodData[],
    periodCadence: Periods,
): number[] => {
    if (!budgetClassifications.length || !periods?.length) return [];

    const periodCount = periods.length;

    const totals = new Array(periodCount).fill(0);

    budgetClassifications.forEach(highLevel => {
        let highLevelPeriods = highLevel.periodData || [];
        if (periodCadence === Periods.ANNUALLY) {
            highLevelPeriods = highLevel.yearlyPeriodData || [];
        }

        let currentPeriodReached = false;

        highLevelPeriods.forEach((period, periodIndex) => {
            const periodDisplayValue = getUsesPeriodDisplayValue(period, currentPeriodReached);
            totals[periodIndex] += periodDisplayValue.value;
            currentPeriodReached = periodDisplayValue.currentPeriodReached;
        });
    });

    return totals;
};
